// extracted by mini-css-extract-plugin
export default {"giftOrPromoRowWrapper":"wA-z","giftOrPromoSelector":"xA-z","disabled":"yA-z","subTitle":"zA-z","selectShipAddressMessage":"AA-z","changePayment":"BA-z"};